import './video-bar-item.component.scss';
import { linkify } from '../../../../utils/a11y.utils';

import { h } from 'preact';

import type { Video } from '../../../models/video.interface';
import { VideoType } from '../../../models/video.interface';

export interface VideoBarItemProps {
  key?: string;
  video: Video;
  showCardDropShadow: boolean;
  showBadge: boolean;
  badgeText: string;
  showDate: boolean;
  showTitle: boolean;
  showArtist: boolean;
}

export const VideoBarItem = ({
  key,
  video,
  showCardDropShadow = false,
  showBadge = false,
  badgeText = '',
  showDate = false,
  showTitle = false,
  showArtist = false,
}: VideoBarItemProps) => {
  if (!video) return null;

  const goToVideo = ($event: any): void => {
    $event.preventDefault();
    $event.stopPropagation();

    window.open(`${window.location.origin}/apps/single/video?content-id=${video.id}`, '_self');
  };

  const formatDate = (date: any) => {
    // Example: 'Aug 23 • 12:00 AM CDT'
    const dateObj = new Date(date);
    const options: any = {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    };
    return dateObj.toLocaleString('en-US', options).replace(',', ' •');
  };

  return (
    <div
      class="single-card-video single-accessibility"
      title={video.name}
      {...linkify(goToVideo, video.name)}
    >
      <div
        class={`single-card-image-wide ${showCardDropShadow ? 'has-shadow' : ''}`}
        style={{ backgroundImage: `url(${video.thumbnailUrl})` }}
      >
        {showBadge && video.premium && <div class="single-video-badge">{badgeText}</div>}

        {showDate && video.videoType === VideoType.Live && (
          <div class="single-video-event-date">{formatDate(video.eventDate)}</div>
        )}

        {showDate && video.videoType === VideoType.VOD && (
          <div class="single-video-time">{video.duration}</div>
        )}
      </div>

      {(showTitle || showArtist) && (
        <div class="single-video-bar-item-info">
          {showTitle && (
            <h4 class={`single-video-title ${showArtist ? 'single-artist-visible' : ''}`}>
              {video.name}
            </h4>
          )}

          {showArtist && <h6 class="single-video-description">{video.artistName}</h6>}
        </div>
      )}
    </div>
  );
};
